import React from 'react';
import MainScreen from './screens/MainScreen';
import './App.css';

function App() {
  return (
   
    <div  className="App">

      <MainScreen />

    </div>
  );
}

export default App;
